// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Jq-z","breadcrumbForward":"Kq-z","breadcrumbBack":"Lq-z","selected":"Mq-z"};